import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import DepartmentTopbar from "../SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "../SuperAdmin/components/DepertmentSidebar";

function AddHfaBeneficiary() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    Beneficiary_code: "",
    Beneficiary_name: "",
    Beneficiary_fathername: "",
    ward_no: "",
  });

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/add_hfa_beneficiary.php`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Beneficiary added successfully!");
        navigate("/departmentDashboard/hfa-beneficiary-list");
      } else {
        toast.error(response.data.message || "Failed to add beneficiary.");
      }
    } catch (error) {
      toast.error("An error occurred while adding the beneficiary.");
      console.error("API Error:", error);
    }
  };

  const wardOptions = Array.from({ length: 25 }, (_, i) => i + 1);

  return (
    <>
      <DepartmentTopbar />
      <div className="d-flex" style={{ minHeight: "calc(100vh - 56px)" }}>
        <DepartmentSidebar />
        <Container fluid className="p-4 bg-light">
          <h2 className="mb-4">Add New HFA Beneficiary</h2>
          <Row>
            <Col>
              <Card className="shadow-sm">
                <Card.Header
                  as="h5"
                  style={{
                    backgroundColor: "#e3f2fd",
                    borderBottom: "2px solid #1976d2",
                  }}
                >
                  <span style={{ color: "#1976d2" }}>
                    Beneficiary Details Form
                  </span>
                </Card.Header>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="Beneficiary_code">
                        <Form.Label>Beneficiary Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="Beneficiary_code"
                          value={formData.Beneficiary_code}
                          onChange={handleChange}
                          placeholder="Enter Beneficiary Code"
                          required
                        />
                      </Form.Group>
                      <Form.Group as={Col} md="6" controlId="ward_no">
                        <Form.Label>Ward No</Form.Label>
                        <Form.Select
                          name="ward_no"
                          value={formData.ward_no}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Ward...</option>
                          {wardOptions.map((ward) => (
                            <option key={ward} value={ward}>
                              {ward}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="6" controlId="Beneficiary_name">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="Beneficiary_name"
                          value={formData.Beneficiary_name}
                          onChange={handleChange}
                          placeholder="Enter Beneficiary Name"
                          required
                        />
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="Beneficiary_fathername"
                      >
                        <Form.Label>Father's Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="Beneficiary_fathername"
                          value={formData.Beneficiary_fathername}
                          onChange={handleChange}
                          placeholder="Enter Father's Name"
                          required
                        />
                      </Form.Group>
                    </Row>
                    <Button variant="primary" type="submit" className="mt-2">
                      Save Beneficiary
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default AddHfaBeneficiary;
